import { useTheme } from "@emotion/react";
import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { AdminActivitiesProvider } from "../../contexts/AdminActivitiesContext";
import useI18nContext from "../../hooks/general/useI18nContext";
import Dialog from "../Dialog";
import BackButton from "../BackButton";
import useCurrentUserQuery from "../../hooks/auth/useCurrentUserQuery";
import { GoSettings } from "react-icons/go";
import { MdFileDownload } from "react-icons/md";
import PrimaryAndSecondaryTypography from "../PrimaryAndSecondaryTypography";
import useAdminActivitiesContext from "../../hooks/general/useAdminActivitiesContext";
import AdminManageActivitiesFiltersForm from "./AdminManageActivitiesFiltersForm";
import ActivitiesList from "../ActivitiesList";
import useUsersQuery from "../../hooks/users/useUsersQuery";
import useToggle from "../../hooks/general/useToggle";
import ActivitiesDownloadDialog from "../ActivitiesDownloadDialog";

export default function AdminManageUsers() {
	return (
		<AdminActivitiesProvider>
			<AdminManageActivitiesComponent />
		</AdminActivitiesProvider>
	);
}

function AdminManageActivitiesComponent() {
	const { query, toggleOpen, isOpen, updateQuery } =
		useAdminActivitiesContext();
	const { zIndex, palette, spacing } = useTheme();
	const { t } = useI18nContext();
	const { data: users } = useUsersQuery();
	const { data: currentUserRegion } = useCurrentUserQuery({
		select: (d) => d?.region,
	});
	const [downloadDialogOpen, toggleDownloadDialog] = useToggle();

	return (
		<>
			<BackButton />
			<PrimaryAndSecondaryTypography
				primary={t?.manageActivities}
				primaryProps={{ variant: "h3", style: { margin: 0 } }}
				containerProps={{ py: 1 }}
			/>
			<Box
				sx={{
					position: "sticky",
					top: 0,
					paddingTop: spacing(1),
					paddingBottom: spacing(1),
					zIndex: zIndex.appBar,
					backgroundColor: palette.background.paper,
					borderBottom: `1px solid ${palette.divider}`,
				}}
			>
				<Button
					startIcon={<GoSettings size={16} />}
					onClick={toggleOpen}
					variant='outlined'
				>
					{t?.filterResults}
				</Button>
				<Button
					startIcon={<MdFileDownload size={16} />}
					sx={{ mx: 1 }}
					variant='outlined'
					onClick={toggleDownloadDialog}
				>
					{t?.download}
				</Button>
			</Box>
			<ActivitiesList query={query} />
			<Dialog
				open={isOpen}
				onClose={toggleOpen}
				title={t?.filterResults}
				maxWidth='xs'
				fullWidth
			>
				<AdminManageActivitiesFiltersForm
					defaultValues={{
						region: currentUserRegion,
						status: "all",
						...query,
					}}
					onCancel={toggleOpen}
					onSubmit={(v) => {
						updateQuery(v);
						toggleOpen();
					}}
				/>
			</Dialog>
			{downloadDialogOpen && (
				<ActivitiesDownloadDialog
					open
					onClose={toggleDownloadDialog}
					query={query}
					users={users}
				/>
			)}
		</>
	);
}
